"use client";

import { useMemo } from "react";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useSearchParams } from "next/navigation";
import { getAddress, isAddress } from "viem";

import type { SupWeb3Address } from "@/types";

/**
 * Get web3 user address of the authenticated user OR the address from special debugging URL
 * @return {SupWeb3Address | undefined}
 */
export default function useWeb3UserAddress(): SupWeb3Address | undefined {
  const { primaryWallet } = useDynamicContext();
  const searchParams = useSearchParams();

  return useMemo(() => {
    const addressParam = searchParams.get("_usewallet") || "";
    const walletAddress = primaryWallet?.address || "";
    if (addressParam && isAddress(addressParam)) {
      return addressParam;
    }

    if (walletAddress && isAddress(walletAddress)) {
      return getAddress(walletAddress);
    }
    return undefined;
  }, [searchParams, primaryWallet]);
}
